export default __webpack_public_path__ + "static/media/mw3.64181357.webp";